import React, { useEffect, useState } from "react";
import classes from "./SortingVisualizer.module.css";
import mergeSort from "../Annimations/Megersort";
import QuickSort from "../Annimations/QuickSort";
import Bubblesort from "../Annimations/Bubblesort";
import InsertionSort from "../Annimations/InsertionSort";
const PRIMARY_COLOR = "turquoise";

const SortingVisualizer = () => {
  const [array, setArray] = useState([]);
  const [speed, setspeed] = useState(10);

  const [copiedArray, setCopiedArray] = useState([]);
  const [size, setsize] = useState(50);

  function handleSizeChange(event) {
    setsize(event.target.value);
  }

  useEffect(() => {
    resetarray();
  }, [size]);

  function resetarray() {
    const array = [];
    for (let i = 0; i < size; i++) {
      array.push(randomIntFromIntervals(5, 500));
    }
    setCopiedArray(array.slice());
    setArray(array);
  }

  function addSelected(event) {
    const resetbtn = document.getElementById("reset_btn");
    const inputs = document.getElementById("inputs");

    const quicksort = document.getElementById("QuickSort");
    const mergesort = document.getElementById("MergeSort");
    const bubblesort = document.getElementById("BubbleSort");
    const insertionsort = document.getElementById("InsertionSort");
    if (event.target.id !== "QuickSort") {
      quicksort.classList.add(`${classes.disable}`);
    }
    if (event.target.id !== "MergeSort") {
      mergesort.classList.add(`${classes.disable}`);
    }
    if (event.target.id !== "BubbleSort") {
      bubblesort.classList.add(`${classes.disable}`);
    }
    if (event.target.id !== "InsertionSort") {
      insertionsort.classList.add(`${classes.disable}`);
    }
    inputs.classList.add(`${classes.disable}`);

    resetbtn.classList.add(`${classes.disable}`);
    event.target.classList.add(`${classes.selected}`);
  }
  return (
    <div>
      <div className={classes.header_container}>
        <h1 className={classes.heading}>Sorting Visualizer</h1>
      </div>
      <div className={classes.navbar}>
        <button
          id="reset_btn"
          onClick={() => resetarray()}
          className={`${classes.reset_button} ${classes.btn} `}
        >
          NEW ARRAY!
        </button>
        <div id="inputs" className={classes.input_container}>
          <span className={classes.input}>
            SPEED
            <input
              type="range"
              id="speed"
              min={1}
              max={40}
              value={speed}
              onChange={(event) => {
                setspeed(event.target.value);
              }}
            ></input>
          </span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span className={classes.input}>
            SIZE
            <input
              type="range"
              id="size"
              min={10}
              max={150}
              value={size}
              onChange={(event) => {
                handleSizeChange(event);
              }}
            ></input>
          </span>
        </div>
        <div className={classes.buttons}>
          <button
            id="MergeSort"
            onClick={(event) => {
              mergeSort({ array, speed });
              addSelected(event);
            }}
            className={`${classes.merge_button} ${classes.btn}`}
          >
            MERGE SORT
          </button>
          <button
            id="QuickSort"
            onClick={(event) => {
              QuickSort({ array, speed });
              addSelected(event);
            }}
            className={`${classes.quick_button} ${classes.btn}`}
          >
            QUICK SORT
          </button>

          <button
            id="InsertionSort"
            onClick={(event) => {
              InsertionSort({ array, speed });
              addSelected(event);
            }}
            className={`${classes.heap_button} ${classes.btn}`}
          >
            INSERTION SORT
          </button>
          <button
            id="BubbleSort"
            onClick={(event) => {
              Bubblesort({ array, speed });
              addSelected(event);
            }}
            className={`${classes.bubble_button} ${classes.btn}`}
          >
            BUBBLE SORT
          </button>
        </div>
      </div>

      <div className={classes.array_container}>
        {copiedArray.map((value, idx) => (
          <div
            className={`${classes.array_bar} array-bar`}
            key={idx}
            style={{
              backgroundColor: PRIMARY_COLOR,
              height: `${value}px`,
            }}
          ></div>
        ))}
      </div>
      <p className={classes.footer}>made by @anurag</p>
    </div>
  );
};

function randomIntFromIntervals(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
export default SortingVisualizer;
